import React from "react"

import { CheckCircle2, CircleDot, MapPin, RotateCcw, Truck } from "lucide-react"

export const getStatusIcon = (status: string, size = 14) => {
  switch (status) {
    case "not_started":
      return <CircleDot size={size} className="text-palette-jungleGreen400" />
    case "en_route":
      return <Truck size={size} className="text-blue-500" />
    case "final_approach":
      return <Truck size={size} className="text-orange-500" />
    case "arrived":
      return <MapPin size={size} className="text-amber-500" />
    case "processing":
      return <RotateCcw size={size} className="animate-spin text-purple-500" />
    case "completed":
      return <CheckCircle2 size={size} className="text-emerald-500" />
    case "departed":
      return <Truck size={size} className="text-palette-jungleGreen400" />
    default:
      return <CircleDot size={size} className="text-palette-jungleGreen400" />
  }
}

export const getStatusColor = (status: string) => {
  switch (status) {
    case "not_started":
      return "bg-palette-jungleGreen100 text-palette-jungleGreen600 border-palette-jungleGreen200"
    case "en_route":
      return "bg-blue-100 text-blue-700 border-blue-200"
    case "final_approach":
      return "bg-orange-100 text-orange-700 border-orange-200"
    case "arrived":
      return "bg-amber-100 text-amber-700 border-amber-200"
    case "processing":
      return "bg-purple-100 text-purple-700 border-purple-200"
    case "completed":
      return "bg-emerald-100 text-emerald-700 border-emerald-200"
    case "departed":
      return "bg-palette-jungleGreen100 text-palette-jungleGreen600 border-palette-jungleGreen200"
    default:
      return "bg-palette-jungleGreen100 text-palette-jungleGreen600 border-palette-jungleGreen200"
  }
}

export const getDelayColor = (delayMinutes: number | undefined) => {
  if (!delayMinutes) return "text-emerald-600"
  if (delayMinutes > 10) return "text-rose-600"
  if (delayMinutes > 0) return "text-amber-600"
  if (delayMinutes < -5) return "text-cyan-600"
  return "text-emerald-600"
}
